import { render, staticRenderFns } from "./ProfileSet.vue?vue&type=template&id=35de0908&scoped=true&"
import script from "./ProfileSet.vue?vue&type=script&lang=js&"
export * from "./ProfileSet.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSet.vue?vue&type=style&index=0&id=35de0908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de0908",
  null
  
)

export default component.exports